// extracted by mini-css-extract-plugin
export default {"shadowed":"About_shadowed__iRrvn","pink":"About_pink__X1YoI","green":"About_green__i+-my","skills":"About_skills__FCnLv"};